import api from "src/configs/api";
import {
  GET_ME, 
  GET_TOKEN, 
  GET_PROJECTS, 
  GET_PROJECT_DETAIL, 
  GET_PROJECT_ROLE,
  GET_SERVER_STATUS,
  POST_REBOOT_SERVER,
  GET_USER_LIST
} from "src/constant/endpoint";

const getMe = () => api.get(GET_ME).then((response) => response?.data?.data);
const getProjectList = () => api.get(`${GET_PROJECTS}?page=1&limit=9999&status=open&order_by=name`).then((response) => response?.data?.data);
const getProjectDetail = (id) => api.get(GET_PROJECT_DETAIL(id)).then((response) => response?.data?.data);
const getProjectRole = (id) => api.get(GET_PROJECT_ROLE(id)).then((response) => response?.data?.data);
const getAccessToken = ({ data }) => api.post(GET_TOKEN, { data }).then((response) => response?.data);
const getServerStatus = () => api.post(GET_SERVER_STATUS).then((response) => response?.data?.data);
const rebootServer = () => api.post(POST_REBOOT_SERVER).then((response) => response?.data?.data);
const getUserList = (id) => api.get(`${GET_USER_LIST}?limit=9999999&page=1`).then((response) => response?.data?.data);

export { 
  getMe, 
  getAccessToken, 
  getProjectList, 
  getProjectDetail, 
  getProjectRole,
  getServerStatus,
  rebootServer,
  getUserList
};
